export class VideoTag{
  hash: string;

  constructor(object = null){

    if(object){
      this.set(object);
    }
  };

  set(object){
    if(object.hash){
      this.hash = object.hash;
    }
  }

  serialize(){
    let object = {
      "hash": this.hash
    };
    return object;
  }
}